/** @file Whether a tile is sheet-backed: its slot names the entry's own sheet image (R1 post-reconcile note). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** True when `entry.slots[tile]` is `puppet.sheets[entry.sheet].image` (cut from the strip at its rect). */
export function sheetTileOf(puppet: Pick<Puppet, 'sheets'>, entry: Pick<FacetEntry, 'sheet' | 'slots'>, tile: number): boolean {
  const image = entry.slots[String(tile)];
  const sheet = Object.hasOwn(puppet.sheets, entry.sheet) ? puppet.sheets[entry.sheet] : undefined;
  return image !== undefined && sheet !== undefined && image === sheet.image;
}
